import { useLazyQuery } from '@apollo/client';
import { useCallback } from 'react';

import { DocumentConnectorCodeEnum } from '../../../../modules/document/types/documentConnectorCode';
import {
	FETCH_DOCUMENT_CONNECTORS,
	FetchDocumentConnectorsResultType,
	FetchDocumentConnectorsVariablesType,
} from '../../../api/documentConnector';

const useDocumentConnectorsDataSource = () => {
	const [fetchDocumentConnectors] = useLazyQuery<
		FetchDocumentConnectorsResultType,
		FetchDocumentConnectorsVariablesType
	>(FETCH_DOCUMENT_CONNECTORS);

	const dataSource = useCallback(
		async (
			limit: number,
			offset: number,
			search?: string,
		): Promise<{
			count: number;
			items: { code: DocumentConnectorCodeEnum | null; name: string }[];
		}> => {
			const { data, error } = await fetchDocumentConnectors({
				variables: {
					page: { limit, offset },
					search,
				},
			});

			if (error) {
				throw error;
			}

			const {
				document_connectors: { count = 0, items = [] },
			} = data ?? {
				document_connectors: {},
			};

			const returnedItems: { code: DocumentConnectorCodeEnum | null; name: string }[] = items;
			const returnedCount = count + 1;

			if (offset === 0) {
				returnedItems.unshift({ code: null, name: 'Aucun' });
			}

			return {
				count: returnedCount,
				items: returnedItems,
			};
		},
		[fetchDocumentConnectors],
	);

	return { dataSource };
};

export default useDocumentConnectorsDataSource;
